/**
 * Guarda a origem da visita para que ela sobreviva ao login e ao redirecionamento.
 *
 * Entre o clique no anúncio (e-mail, aviso no navegador) e a candidatura acontecem
 * login e troca de rota, e a query some no caminho. Quem lê depois é a tela de
 * candidatura, que grava a origem em `applications_sources`.
 */
const UTM_KEYS = ["utm_source", "utm_campaign", "utm_medium"];

/**
 * Query string vira string vazia quando o parâmetro não veio, e `undefined` vira
 * a palavra "undefined" ao ser gravada — um valor que parece preenchido e
 * contamina a atribuição da candidatura.
 */
export function sanitizeUtmValue(value) {
  if (value === undefined || value === null) return null;

  const text = String(value).trim();
  if (!text || text === "undefined" || text === "null") return null;

  return text;
}

/** Guarda as utms presentes na query, sem apagar as que já estavam lá. */
export function persistUtms(query = {}) {
  UTM_KEYS.forEach((key) => {
    const value = sanitizeUtmValue(query[key]);
    if (!value) return;

    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      // sessionStorage indisponível: a utm da query ainda vale nesta navegação.
    }
  });
}

/** Lê uma utm guardada, já sem os valores-lixo das versões anteriores. */
export function readUtm(key) {
  try {
    return sanitizeUtmValue(sessionStorage.getItem(key));
  } catch (e) {
    return null;
  }
}

/** As três utms guardadas, para montar o corpo da candidatura. */
export function readUtms() {
  return {
    utm_source: readUtm("utm_source"),
    utm_campaign: readUtm("utm_campaign"),
    utm_medium: readUtm("utm_medium"),
  };
}
